import i18n from "i18next"
import detector from "i18next-browser-languagedetector"
import { initReactI18next } from "react-i18next"

import translationFr from "./locales/fr/translation.json"
import translationIU from "./locales/iu/translation.json"
import translationES from "./locales/es/translation.json"
import translationEN from "./locales/en/translation.json"
import translationAR from "./locales/ar/translation.json"
import translationDE from  "./locales/de/translation.json"
import transaltionKU from "./locales/ku/translation.json"

// the translations
const resources = {
  FR: {
    translation: translationFr,
  },
  IU: {
    translation: translationIU,
  },
  ES: {
    translation: translationES,
  },
  EN: {
    translation: translationEN,
  },
  AR : {
    translation : translationAR
  },
  DE : {
    translation : translationDE
  },
  KU : {
    translation : transaltionKU
  }
}
const language = localStorage.getItem("I18N_LANGUAGE")
if (!language) {
  localStorage.setItem("I18N_LANGUAGE", "en")
}

i18n
  .use(detector)
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    resources,
    lng: localStorage.getItem("I18N_LANGUAGE") || "en",
    fallbackLng: "en", // use en if detected lng is not available

    keySeparator: false, // we do not use keys in form messages.welcome

    interpolation: {
      escapeValue: false, // react already safes from xss
    },
  })

export default i18n
